
<div class="row">
  <div class="col-md-4">
    <!-- card-width="250"  [messages]="messages" [masks]="masks"  [placeholders]="{name:cardOwnerName}"-->
    <div [formGroup]="mainForm" card container=".card-container" 
      formatting="false" debug="true">

      <div class="row">
        <div class="col-md-12">  
          <mat-form-field class="full-width">
          <input matInput #cardNumber type="text" placeholder="Número do cartão" formControlName="number" card-number />
        </mat-form-field>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">  
        <mat-form-field class="full-width">
        <input matInput #cardName type="text" formControlName="name"  placeholder="Nome no cartão"  card-name />
      </mat-form-field>
      </div>
      </div>
      <div class="row">
        <div class="col-md-6">
        
          <mat-form-field class="full-width">
            <input matInput #cardExpiry type="text" formControlName="expiry"  placeholder="Validade"  card-expiry />
          </mat-form-field>

        </div>
        <div class="col-md-6">
     

          <mat-form-field class="full-width">
            <input matInput #cardCvc type="text" formControlName="cvc"  placeholder="Código"  card-cvc/>
          </mat-form-field>

        </div>
      </div>

    </div>
  </div>
  <div class="col-md-3">
    <div class="card-container"  (click)="clickOnCard()"></div>
  </div>
</div>